
import gsap from 'gsap';

function shuffleText(text) {
    const chars = text.split('');
    for (let i = chars.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [chars[i], chars[j]] = [chars[j], chars[i]];
    }
    return chars.join('');
}

const applyMirrorEffect = (element) => {
    // Stocké au init, pas au hover
    const originalText = element.innerText.trim() || element.textContent.trim();
    if (!originalText) return;

    let tw = null;

    element.onmouseenter = () => {
        element.setAttribute('aria-label', originalText);


        if (tw) tw.kill();

        const passes = 4;
        const duration = 0.25;
        const step = duration / passes;

        tw = gsap.timeline({
            onComplete: () => {
                element.innerText = element.getAttribute('aria-label');
                element.removeAttribute('aria-label');
                element.style.fontKerning = '';
            }
        });

        for (let i = 0; i < passes; i++) {
            tw.call(() => {
                element.style.fontKerning = 'none';
                element.innerText = shuffleText(element.getAttribute('aria-label'));
            }, null, step * i);
        }
    };

    element.onmouseleave = () => {
        if (tw) tw.kill();
        const original = element.getAttribute('aria-label');
        if (original) {
            element.innerText = original;
            element.removeAttribute('aria-label');
        }
        element.style.fontKerning = '';
    };
};

export const initScrambleLinks = () => {
    document.fonts.ready.then(() => {
        const selectors = [
            '.scramble-link',
            '#hero-explore-btn',
            '.menu-item a',
            'header nav a',
            '#down_menu a',
            '#mobile-menu a'
        ];

        document.querySelectorAll(selectors.join(', ')).forEach(el => {
            if (!el.dataset.scrambleInit) {
                applyMirrorEffect(el);
                el.dataset.scrambleInit = "true";
            }
        });
    });
};